(() => {
  const initializeProductControls = (scope = document) => {
    const sections = [];

    if (scope.matches && scope.matches('section[id^="MainProduct-"]')) {
      sections.push(scope);
    }

    if (scope.querySelectorAll) {
      sections.push(...scope.querySelectorAll('section[id^="MainProduct-"]'));
    }

    sections.forEach((section) => {
      const quantity = section.querySelector('[id^="Quantity-Form-"]');
      const buttons = section.querySelector(
        '.ovelis-buy-buttons-block .product-form__buttons'
      );

      if (!quantity || !buttons) return;

      buttons.classList.add('ovelis-product-actions');
      quantity.classList.add('ovelis-product-actions__quantity');

      if (quantity.parentElement !== buttons) {
        buttons.insertBefore(quantity, buttons.firstElementChild);
      }
    });
  };

  if (!window.ovelisProductControlsInitialized) {
    window.ovelisProductControlsInitialized = true;

    document.addEventListener('shopify:section:load', (event) => {
      initializeProductControls(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initializeProductControls(document),
      { once: true }
    );
  } else {
    initializeProductControls(document);
  }
})();
